import router from './router/index' // 路由
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
})

router.beforeEach((to, from, next) => {
 if (to.name == "/report" || to.name == "/reportSubmit") {
   document.title = "清朗·网络直播领域虚假和低俗乱象整治——代县融媒体中心";
 }
 if (to.name == "/harm" || to.name == "/harmSubmit") {
   document.title = "山西省互联网违法和不良信息举报中心——代县融媒体中心";
 }
  next();
});



// WEBPACK FOOTER //
// ./src/permissions.js